import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import LoaderBox from '../../components/LoaderBox';
import Routes, { ERoutes } from '../../routes';
import { ApplicationState } from '../../store';
import { tokenValidate } from '../../store/ducks/user/actions';
import { Modal, Button, Input } from 'antd';
import { EGerdauService } from '../../services/EGerdauService';
import { loadLongSteelShoppingCartFromLocalStorage } from '../../store/ducks/long-steel-shopping-cart/actions';
import { ECustomerTypeView } from '../../store/ducks/user/types';
import UserSession from './UserSession';
import { initializeObservability } from '../../store/ducks/observability/actions';
import ToastRoot from '../../components/ToastRoot';
import { ToggleButton } from '@gerdau/hefesto';
import { Container, Line, ContentCenter } from './styles';
import TokenManager from '../../services/Auth/tokenManager';
import {
  IRefreshAuthToken,
  RENEW_TOKEN_INTERVAL_MILLISECONDS
} from '../../store/ducks/auth/types';
import { loadAuthState } from '../../store/ducks/auth/actions';
import { CookiesKey } from '../../services/Auth/enums';
import { RefreshAuthTokenService } from '../../services/Auth';
import { v4 as uuidv4 } from 'uuid';

const Landing: React.FC = () => {
  const dispatch = useDispatch();
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const userId = useSelector((state: ApplicationState) => state.user.id);
  const userLoading = useSelector(
    (state: ApplicationState) => state.user.loading
  );
  const userError = useSelector((state: ApplicationState) => state.user.error);
  const userEmail = useSelector((state: ApplicationState) => state.user.email);
  const userPermissions = useSelector(
    (state: ApplicationState) => state.user.userPermissions
  );
  const searchCustomerType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );

  const [isExecutingLocal] = useState(
    window.location.origin.includes('localhost')
  );

  useEffect(() => {
    const firstLoginMatch = window.location.href.includes(ERoutes.FIRST_LOGIN);

    if (!userId && !userLoading && !userError && !firstLoginMatch) {
      dispatch(tokenValidate());
      if (searchCustomerType === ECustomerTypeView.EMITTER) {
        dispatch(loadLongSteelShoppingCartFromLocalStorage());
      }
    }
  }, [
    customersState.error,
    searchCustomerType,
    userId,
    userLoading,
    userError
  ]);

  const [hasStartedGlobalbot, setHasStartedGlobalbot] = useState(false);

  const startGlobalbot = () => {
    const script = document.createElement('script');
    script.src =
      'https://globalbot.ai/init/1/5D39F3267AB4BF0BCAFF3342A91092F9-30D1-0820-4D27-66A124769EF4';
    script.integrity =
      'sha384-oqVuAfXRKap7fdgcCY5uykM6+R9GqQ8K/uxy9rx7HNQlGYl1kPzQho1wx4JwY8wC';
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
    setHasStartedGlobalbot(true);
  };

  useEffect(() => {
    if (
      !userLoading &&
      userEmail &&
      !userPermissions.hasFabricationAccess &&
      !hasStartedGlobalbot
    ) {
      startGlobalbot();
    }
  }, []);

  // Inicia Observability apos usuario estar logado
  useEffect(() => {
    dispatch(initializeObservability());
  }, [userId]);

  // useEffect(() => {
  //   const refreshAuthTokenService = new RefreshAuthTokenService();
  //   const azureToken = refreshAuthTokenService.getValueCookie(
  //     CookiesKey.AUTHORIZATION_TOKEN
  //   ) as string;
  //   const azureDateTimeExpiration = refreshAuthTokenService.getValueCookie(
  //     CookiesKey.AUTHORIZATION_TOKEN_EXPIRATION
  //   ) as string;

  //   dispatch(loadAuthState(azureToken, Number(azureDateTimeExpiration)));
  // });

  // MOCK TOKEN
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [token, setToken] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [authTokenExpiry, setAuthTokenExpiry] = useState('');
  const [azure, setAzure] = useState(false);
  const submitToken = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    EGerdauService.setToken(token);
    EGerdauService.setSsoAccess(azure);
    EGerdauService.setProfileAccessToken(token);
    EGerdauService.setAuthorizationToken(authToken);
    EGerdauService.setAuthorizationTokenExpiration(authTokenExpiry);
    EGerdauService.setCorrelationId(uuidv4());
    setShowTokenModal(false);
    dispatch(tokenValidate());
    dispatch(loadAuthState(authToken, Number(authTokenExpiry)));
  };

  // mock get azure token call
  useEffect(() => {
    if (isExecutingLocal) {
      const refreshAuthTokenService = new RefreshAuthTokenService();

      const fetchAuthToken = async () => {
        try {
          const response: IRefreshAuthToken =
            await refreshAuthTokenService.refreshAuthToken();

          if (response != null) {
            const azureDateTimeExpiration =
              new Date().getTime() + RENEW_TOKEN_INTERVAL_MILLISECONDS;
            setAuthToken(response.access_token);
            setAuthTokenExpiry(azureDateTimeExpiration.toString());
          }
        } catch (error) {
          console.error('Erro ao atualizar o token de autenticação:', error);
        }
      };

      fetchAuthToken();
    }
  }, []);

  return (
    <BrowserRouter>
      <ToastRoot />
      <TokenManager />

      {userLoading && <LoaderBox />}

      {userError && isExecutingLocal && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          {/* MOCK TOKEN */}
          <Button
            // type="primary"
            style={{ position: 'relative', margin: 'auto' }}
            onClick={() => setShowTokenModal(true)}
          >
            Inserir token
          </Button>

          <Modal
            visible={showTokenModal}
            onCancel={() => setShowTokenModal(false)}
            closable={true}
            width={600}
            footer={false}
            title="Inserir Token"
          >
            <Container>
              <form onSubmit={(e) => submitToken(e)}>
                <Line>
                  <ToggleButton
                    ariaLabel="Azure?"
                    label="Azure?"
                    name="sso-access"
                    onChange={(event) => setAzure(event.target.checked)}
                  />
                </Line>
                <ContentCenter>
                  <Input
                    autoFocus
                    placeholder="Insira o token aqui"
                    onChange={(e) => setToken(e.target.value)}
                  />
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={token.length < 10}
                  >
                    Confirmar
                  </Button>
                </ContentCenter>
              </form>
            </Container>
          </Modal>
        </div>
      )}

      {!userLoading && !userError && (
        <>
          <UserSession userId={userEmail} />
          <Routes />
        </>
      )}
    </BrowserRouter>
  );
};

export default Landing;
